import React from 'react';
import $ from "jquery";
import {debounce} from 'lodash';
import {connect} from 'react-redux';
import {modifyPageLayoutComponents} from '../PageLayout';

import template from '../../templates/NewScope/NewScope.rt';
import NewScopeHeaderTemplate from "../../templates/NewScope/NewScopePageHeader.rt";

import {
  getQtCategories,
  deleteQtCategory,
  postQtCategory,
  postQtCategories,
  toggleQtCategoryImagePopup,
  setQtCategories,
  setActiveQtCategoryIndex,
  setFeatureGroupSearchValue,
  setCategoriesVisualizer,
  unloadQTCategories,
  getFabricatorSubscriptions
} from "./newScopeActions";
import PS from '../ProjectScope/ProjectScopeActionsNew';

import {arrayMove} from "../../utilities/helpers";
import {loadingDialog_show} from "../../actions";

class NewScope extends React.Component {

  state = {
    searchValue: "",
    qtFiteredCategories: [],
    wizardListFiltered: [],
  };

  async componentDidMount() {
    this.props.loadingDialog_show(true, 'Loading...', 'Loading features groups, this will take just a moment.');
    const subscriptions = await this.props.getFabricatorSubscriptions();
    if (!subscriptions || !subscriptions.length) {
      this.props.loadingDialog_show(false);
      return false
    }
    let visualizerType = this.props.categoriesVisualizer;
    if (subscriptions.length === 1 && visualizerType !== subscriptions[0].service) {
      visualizerType = subscriptions[0].service;
    }
    Promise.all([this.setVisualizerType(visualizerType), this.props.loadFeaturesGroups(false)])
      .then((response) => {
        if (response.every(condition => condition)) {
          this.props.loadingDialog_show(false);
        }
      });
  }

  componentWillUnmount() {
    this.props.setSearchTerm("");
    this.props.unloadFeaturesGroups();
  }

  handleSearchInputChange(searchValue) {
    let matchValue = searchValue.toLowerCase().trim();
    this.setState({
      searchValue,
      qtFiteredCategories: this.props.qtCategories.filter(qtCategory => {
        let currentName = qtCategory.name.toLowerCase();
        return (qtCategory.name === "All") || currentName.includes(matchValue)
      }),
      wizardListFiltered: this.props.wizardList.filter(wizardItem => {
        let wizardItemName = wizardItem.name.toLowerCase();
        return wizardItemName.includes(matchValue)
      })
    });
    if (this.props.activeQtCategoryIndex !== 0) {
      this.props.setActiveQtCategoryIndex(0);
    }
  }

  shouldCancelStart = (event) => {
    const excludedClassNames = ["assign-sidebar-list__item-checkbox", "assign-sidebar-list__item-remove",
      "assign-sidebar-list__item-edit", "assign-sidebar-list__item-title", "ui-button", "ui-input"];
    if (excludedClassNames.some(className => {
      return event.target.classList.contains(className) || event.target.closest("."+className)
    })) {
      return true
    }
  };

  onSortEnd({ oldIndex, newIndex }) {
    if (oldIndex !== newIndex) {
      const newQtCategories = arrayMove(this.props.qtCategories, oldIndex, newIndex);
      let categoriesToUpdate = [];
      newQtCategories.forEach((category, categoryIndex) => {
        category.order = categoryIndex;
        if ((categoryIndex >= oldIndex) || (categoryIndex >= newIndex)) {
          categoriesToUpdate.push(category);
        }
      });
      //update on backend
      this.props.postQtCategories(categoriesToUpdate);
      //update on frontend
      this.props.setQtCategories(newQtCategories);
      if (this.props.activeQtCategoryIndex === oldIndex) {
        this.props.setActiveQtCategoryIndex(newIndex);
      } else if (this.props.activeQtCategoryIndex < oldIndex
        && (this.props.activeQtCategoryIndex > newIndex || this.props.activeQtCategoryIndex === newIndex)) {
        this.props.setActiveQtCategoryIndex(this.props.activeQtCategoryIndex + 1);
      } else if (this.props.activeQtCategoryIndex > oldIndex
        && (this.props.activeQtCategoryIndex < newIndex || this.props.activeQtCategoryIndex === newIndex)) {
        this.props.setActiveQtCategoryIndex(this.props.activeQtCategoryIndex - 1);
      }
    }
  }

  addNewCategory = () => {
    //console.log(this.props.qtCategories);
    this.props.setQtCategories([...this.props.qtCategories, {
      "name": "", // this name is unique per fabricator
      "bgImage": "",
      "enabled": true,
      "order": this.props.qtCategories.length,
      // "featureGroups": [{
      //     "groupName": "Sink",
      //     "order": 0
      //   },{
      //     "groupName": "Faucet",
      //     "order": 1
      //   }],
      "featureGroups": []
    }]);
    setTimeout(() => {  // after redux update
      const sidebar = $('.assign-sidebar-list');
      sidebar.animate({
        scrollTop: sidebar[0].scrollHeight
      }, 1000);
      sidebar.find(".ui-input:last").focus();
    }, 0)
  };

  setCategoriesVisualizer = (visualizerType) => {
    const hasSubscription = this.props.fabricatorSubscriptions.some(sub => sub.service === visualizerType);
    if ((visualizerType !== this.props.categoriesVisualizer) && hasSubscription) {
      this.setVisualizerType(visualizerType);
      this.props.loadFeaturesGroups(true);
    }
  };

  setVisualizerType = (visualizerType) => {
    this.props.setActiveQtCategoryIndex(0);
    this.props.setCategoriesVisualizer(visualizerType);
    return this.props.getQtCategories(visualizerType);
  }

  render = template
}

const mapStateToProps = (store) => {
  const {qtCategories, activeQtCategoryIndex, featureGroupsSearchValue, qtCategoriesReceived, qtCategoryImageEditIndex,
    categoriesVisualizer, fabricatorSubscriptions, isWizardMode} = store.newScope;
  const {wizardList, wizardListReceived} = store.wizardState;
  const {term} = store.projectScopeNew;

  // console.log(store);
  return {
    qtCategories,
    qtCategoriesReceived,
    qtCategoryImageEditIndex,
    activeQtCategoryIndex,
    featureGroupsSearchValue,
    categoriesVisualizer,
    fabricatorSubscriptions,
    isWizardMode,
    pendingChanges: [...store.projectScopeNew.pendingChanges],
    pendingFeatureChanges: {...store.featuresCreatorNew.pendingFeatures},
    hasPendingFeatureChanges: _.size(store.featuresCreatorNew.pendingFeatures) > 0,
    wizardList,
    wizardListReceived,
    term,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getQtCategories: (visualizerType) => dispatch(getQtCategories(visualizerType)),
    postQtCategory: (qtCategory, update, callback) => dispatch(postQtCategory(qtCategory, update, callback)),
    postQtCategories: (qtCategories) => dispatch(postQtCategories(qtCategories)),
    deleteQtCategory: (qtCategoryId) => dispatch(deleteQtCategory(qtCategoryId)),
    toggleQtCategoryImagePopup: (qtCategoryImageEditIndex) => dispatch(toggleQtCategoryImagePopup(qtCategoryImageEditIndex)),
    setQtCategories: (qtCategories) => dispatch(setQtCategories(qtCategories)),
    setActiveQtCategoryIndex: (activeQtCategoryIndex) => dispatch(setActiveQtCategoryIndex(activeQtCategoryIndex)),
    setSearchTerm: (...args) => debouncedSearchTerm(dispatch, ...args),
    loadFeaturesGroups: (singleRequest) => dispatch(PS.loadFeaturesGroups(singleRequest)),
    setCategoriesVisualizer: (visualizer) => dispatch(setCategoriesVisualizer(visualizer)),
    loadingDialog_show: (show, title, text) => dispatch(loadingDialog_show(show, title, text)),
    unloadFeaturesGroups: () => dispatch(unloadQTCategories()),
    getFabricatorSubscriptions: () => dispatch(getFabricatorSubscriptions())
  };
}

const debouncedSearchTerm = debounce((dispatch, ...args) => dispatch(PS.setSearchTerm(...args)), 300);
const connector = connect(mapStateToProps, mapDispatchToProps);

export const NewScopeLayoutComponents = modifyPageLayoutComponents({
  pageHeader: connector(NewScopeHeaderTemplate),
  content: connector(NewScope)
});
